import { sync } from 'vuex-router-sync';
import router from '@/router';

export const ROUTE_MODULE = 'RouteModule';

export default (store) => {
  sync(store, router, { moduleName: ROUTE_MODULE });
};
